import { render } from "./dropzone.vue?vue&type=template&id=51931fdb&ts=true"
import script from "./dropzone.vue?vue&type=script&lang=ts"
export * from "./dropzone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__